module.exports = __webpack_public_path__ + "media/54.7e3e8619.wav";